export class OrderCheckout
{
  constructor(form) {
    this.form = form;

    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener('submit', (event) => {
      [...this.form.querySelectorAll('button, [type=submit]')].forEach((element) => {
        element.setAttribute('disabled', 'true')
      });
    });
  }
}
